import React, { createContext, useCallback, useState, useContext } from 'react';

type AppProviderProps = {
	children: React.ReactNode;
}
type AcessoDATA = {
  id: number;
  email: string;
  nome: string;
  role: string;
  status: string;
  password?: string;
}
interface AcessoHookState {
  acessoHook: AcessoDATA;
}
interface AcessoHookContexData {
  acessoHook: AcessoDATA;
  setHookAcesso(data: AcessoDATA): void;
  setHookNameEmail(name: string, email: string): void;
  setHookPassword(password: string): void;
  setHookRole(role: string): void;
  resetHookAcesso(): void;
}

const AcessoHookContext = createContext<AcessoHookContexData>(
  {} as AcessoHookContexData,
);

const AcessoHookProvider: React.FC<AppProviderProps> = ({ children }) => {
  const [acessoHook, setAcessoHook] = useState<AcessoDATA>({
    id: 0,
    email: '',
    nome: '',
    role: '',
    status: '',
  });
  const [data, setData] = useState<AcessoHookState>(() => {
    return {} as AcessoHookState;
  });

  const setHookAcesso = useCallback((acess: AcessoDATA) => {
    setAcessoHook(acess);
    setData({
      acessoHook: acess,
    });
  }, []);

  const setHookNameEmail = useCallback((name: string, email: string) => {
      const auxAcesso = acessoHook;
      auxAcesso.nome = name;
      auxAcesso.email = email;

      setAcessoHook(auxAcesso);
      setData({
        acessoHook: auxAcesso,
      });
    },
    [acessoHook],
  );

  const setHookPassword = useCallback((password: string) => {
      const auxAcesso = acessoHook;
      auxAcesso.password = password;

      setAcessoHook(auxAcesso);
      setData({
        acessoHook: auxAcesso,
      });
    },
    [acessoHook],
  );

  const setHookRole = useCallback((role: string) => {
      const auxAcesso = acessoHook;
      auxAcesso.role = role;

      setAcessoHook(auxAcesso);
      setData({
        acessoHook: auxAcesso,
      });
    },
    [acessoHook],
  );

  const resetHookAcesso = useCallback(() => {
    const auxAcesso = {
      id: 0,
      email: '',
      nome: '',
      role: '',
      status: '',
    };
    setAcessoHook(auxAcesso);

    setData({
      acessoHook: auxAcesso,
    });
  }, []);

  return (
    <AcessoHookContext.Provider
      value={{
        acessoHook: data.acessoHook,
        setHookAcesso,
        setHookNameEmail,
        setHookPassword,
        setHookRole,
        resetHookAcesso,
      }}
    >
      {children}
    </AcessoHookContext.Provider>
  );
};

function useAcessoHook(): AcessoHookContexData {
  const context = useContext(AcessoHookContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}

export { AcessoHookProvider, useAcessoHook };
